import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'sweetalert2/dist/sweetalert2.min.css'
import UUID from 'vue-uuid'
import QrcodeVue from 'qrcode.vue'

createApp(App).use(store).use(router).use(UUID).component('qrcode-vue', QrcodeVue).mount('#app')
